<template>
    <div id="checkin-pci-hub" class="choices container">
        <!-- <p class="hub-subtitle">{{ $t('checkin_pci_hub.subtitle') }}</p> -->
        <ul class="nav nav-pills mb-3 row" role="tablist">
            <li class="nav-item p-1 col-12" role="button">
                <a class="nav-link text-center" @click="goToByPhone">
                    <i class="fas fa-phone-alt mr-2" />
                    <div>{{ $t('checkin_pci_hub.by_phone_label') }}</div>
                </a>
            </li>
            <li class="nav-item p-1 col-12" role="button">
                <a class="nav-link text-center" @click="goToByName">
                    <i class="fas fa-user mr-2" />
                    <div>{{ $t('checkin_pci_hub.by_name_label') }}</div>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    methods: {
        goToByPhone() {
            // Full navigation (not $router.push): this route reuses the same MainHotelForm
            // instance as the hub, and Vue Router won't re-run mounted() on an in-place
            // route change, so `action` would never get set for the phone step.
            const { href } = this.$router.resolve({
                name: 'checkin-facility-checkin-by-phone',
                params: { slug_name: this.$route.params.slug_name },
                query: { pci: 'true', back: 'true' },
            });
            window.location.href = href;
        },
        goToByName() {
            const { href } = this.$router.resolve({
                name: 'checkin-facility-checkin-by-name',
                params: { slug_name: this.$route.params.slug_name },
                query: { pci: 'true', back: 'true' },
            });
            window.location.href = href;
        },
    },
};
</script>

<style lang="scss" scoped>
#checkin-pci-hub {
    font-family: "Poppins", sans-serif;

    .hub-subtitle {
        font-size: 14px;
        color: #4d4d4d;
    }

    .nav-item {
        a.nav-link {
            height: 75px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 8px;
            border: 2px solid #1489ff;
            background: #fff;
            color: #1489ff;
            font-size: 14px;
            cursor: pointer;
            box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);

            &:hover {
                background: #1489ff;
                color: #fff !important;
            }
        }
    }
}
</style>
